"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIpWardPharmacyCode = isIpWardPharmacyCode;
/**
 * WARD-BILLED DRUG CHARGES WITH NO DISPENSING MODULE BEHIND THEM.
 *
 * The real Pharmacy module bills a dispensed, inventory-tracked drug through
 * `PharmacySale` and its own IP bridge (`modules/pharmacy-billing`). The three
 * MTM-prefixed Service Master rows (M-DRUGS, M-DIASTICS, M-ANAESTHESIA DRUGS)
 * are a different thing: a lump sum the ward desk types by hand for drugs
 * given without going through that dispensing flow.
 *
 * DELIBERATELY SEPARATE FROM `classifyServiceFamily` (service-family.ts).
 * That classifier also feeds the OP staff-discount engine and OP bill
 * pricing — widening its `LAB | RADIOLOGY` union to include a third family
 * would change a discount rate this fix has no mandate to touch. This file
 * answers a narrower, IP-billing-only question: which unbridged MANUAL
 * charge should the money band's Drugs tile — not Ward — claim.
 *
 * Desk, 2026-09-25: two MTM3 (M-DRUGS) IP lines read "Ward" instead of
 * "Drugs" on the money band, because nothing routed them to the PHARMACY
 * charge group — confirmed live on bill 336631/admission 368737, ₹9,736
 * counted correctly in the running total but shelved under the wrong tile.
 *
 * ONE IMPLEMENTATION, read by both the IP draft summary (which bucket the
 * unapproved tile shows) and the actual capture call (which bucket the
 * captured ledger row is stamped with, forever — `chargeGroup` is
 * snapshotted at capture and never re-derived) — so a line cannot read
 * "Drugs" before approval and "Ward" after.
 */
const IP_WARD_PHARMACY_PREFIXES = ['MTM'];
function isIpWardPharmacyCode(identifier) {
    const code = (identifier ?? '').trim().toUpperCase();
    if (!code)
        return false;
    return IP_WARD_PHARMACY_PREFIXES.some((prefix) => code.startsWith(prefix));
}
//# sourceMappingURL=ip-ward-pharmacy.js.map